import React from 'react';

import { Flex } from '@chakra-ui/react';
import useOneOnOnePageParams from 'screens/oneOnOneRabbit/hooks/useOneOnOnePageParams';

import { InitiativesIconDualTone } from 'assets/assetsV1/iconComponents';

import { sendGivenSatisfactionScore } from 'constants/mixpanelHelper';

import { ColoredStarRating } from 'uiToolkitV1/ColoredStarRating';
import { TextLabel } from 'uiToolkitV1/Typography';

import { CardTemplate } from '../../common/CardTemplate';
import { useOneOnOneInstanceDetails } from '../../hooks/dataHooks';
import { useOneOnOneRatingMutation, useOneOnOneRatingQuery } from './hooks/dataHooks';

const OneOnOneRating = () => {
  const { masterId, instanceId } = useOneOnOnePageParams();
  const { relationType } = useOneOnOneInstanceDetails({
    masterId,
    instanceId,
  });

  const { data } = useOneOnOneRatingQuery({ masterId, instanceId });
  const updateRatingMutation = useOneOnOneRatingMutation({
    masterId,
    instanceId,
  });

  const handleRatingChange = (rating: number) => {
    updateRatingMutation.mutate({
      updatedRating: rating,
    });
    sendGivenSatisfactionScore();
  };

  return (
    <CardTemplate heading="Rate this 1:1" Icon={InitiativesIconDualTone}>
      <Flex ml="24px" my="20px" flexDir="column">
        {relationType === 'MANAGER' ? (
          <TextLabel mb="8px" color="text.g2" bold>
            On a scale of 1-5, how beneficial was your 1:1 meeting with your manager today?
          </TextLabel>
        ) : relationType === 'SKIP_MANAGER' ? (
          <TextLabel mb="8px" color="text.g2" bold>
            On a scale of 1-5, how beneficial was your 1:1 meeting with your skip manager today?
          </TextLabel>
        ) : (
          <TextLabel mb="8px" color="text.g2" bold>
            On a scale of 1-5, how beneficial was your 1:1 meeting today?
          </TextLabel>
        )}
        <ColoredStarRating maxRating={5} rating={data} handleChange={handleRatingChange} />
      </Flex>
    </CardTemplate>
  );
};

export { OneOnOneRating };
